import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {KartenZoomService} from '../../../service/layout/karten-zoom.service';

/**
 * Zoom-Regler für die Grafik-Karten: kleiner / aktueller Wert / größer.
 *
 * Herausgelöst, weil derselbe Regler an mehreren Stellen steht – in der Kopfleiste
 * der Grafik-Ansicht und zusätzlich neben jeder Reihenüberschrift, damit man beim
 * Herunterscrollen nicht nach oben muss.
 *
 * Der Zustand liegt in {@link KartenZoomService} (ein Singleton, das eine
 * CSS-Variable am Wurzelelement setzt). Alle Instanzen dieses Reglers zeigen und
 * verändern deshalb denselben Wert – es braucht keine Synchronisation zwischen ihnen.
 */
@Component({
  selector: 'app-karten-zoom',
  templateUrl: './karten-zoom.component.html',
  styleUrls: ['./karten-zoom.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule]
})
export class KartenZoomComponent {

  /** Kompakte Variante für die Reihenüberschriften. */
  @Input() kompakt = false;

  constructor(public kartenZoom: KartenZoomService) {
  }
}
